var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import RouterService from "@ember/routing/router-service";
import Transition from "@ember/routing/transition";
import Service, { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { version1IsLowerThanVersion2 } from "core/utils/version";
/**
 * A service for communicating with the native mobile application.
 *
 * It follows the Web Worker conventions with:
 *
 * - a postMessage method used by the Web app to send a message to the mobile app,
 * - a onMessage method, used by the native app to send a message to the Web app.
 *
 * Messages are JSON serialized in strings.
 * They are expected to contain a type and a payload.
 * The message is then interpreted depending on the type.
 */
let NativeAppService = (_class = class NativeAppService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _defineProperty(this, "minimumVersions", {
      android: "1.11.0",
      ios: "1.0"
    });
    _defineProperty(this, "androidStoreUrl", "https://play.google.com/store/apps/details?id=io.semeia.mentalwise&hl=fr");
    _defineProperty(this, "iosStoreUrl", "https://apps.apple.com/fr/app/mentalwise/id1539637294");
    _initializerDefineProperty(this, "permissions", _descriptor2, this);
  }
  setPlatform() {
    this._extractInformationFromMobileUserAgent();
    this.postMessage({
      type: "app-is-ready"
    });
  }

  /**
   * @returns true if the Web app is running in the context of the native app.
   */
  get enabled() {
    const nativeAppBridgeMounted = Boolean(window.android || window.webkit?.messageHandlers?.nativeApp);
    return this.platform != undefined && nativeAppBridgeMounted;
  }
  setup() {
    // The native app will access the service through this global attribute.
    window.nativeAppService = this;
    this.setPlatform();
    if (this.enabled) {
      this.router.on("routeDidChange", this._postRouteDidChange.bind(this));
    }
  }

  /**
   * Send a message to the native application.
   */
  postMessage(message) {
    if (!this.enabled) return;
    switch (this.platform) {
      case "ios":
        window.webkit?.messageHandlers?.nativeApp.postMessage(JSON.stringify(message));
        break;
      case "android":
        window.android.postMessage(JSON.stringify(message));
        break;
      // default:

      // console.debug("Platform is not set. Cannot post a message.");
    }
  }

  /**
   * Called by the native to send a message to the Web.
   */
  onMessage(message) {
    const deserialized = JSON.parse(message);
    switch (deserialized.type) {
      case "permission-status-retrieved":
        this._permissionStatusRetrieved(deserialized.payload);
        break;
      default:
        console.error(`Unkown message type sent to the Web app: ${message}`);
    }
  }
  showPermissionPage() {
    this.postMessage({
      type: "show-page",
      payload: {
        page: "onboarding"
      }
    });
  }
  patientLoggedIn() {
    this.postMessage({
      type: "patient-logged"
    });
  }
  _postRouteDidChange({
    from,
    to
  }) {
    if (!to) return;
    const payload = {
      to: to.name
    };

    /**
     * in PR https://github.com/Semeia-io/Platform/pull/8163, the login routes changed
     * But the ios native app has the legacy route "patient-web.login" hardcoded
     * and we cannot update all the native apps on the patient's devices.
     *
     * We handle this special case here to make sure the ios app will properly
     * render the native login view when the ember app transitions to the new
     * login "login.index" route.
     */
    const transitionningToLoginOnIos = this.platform == "ios" && to.name == "login.index";
    if (transitionningToLoginOnIos) payload.to = "patient-web.login";
    if (from) payload["from"] = from.name;
    this.postMessage({
      type: "route-did-change",
      payload
    });
  }
  get shouldShowUpdateMessage() {
    return version1IsLowerThanVersion2(this.version, this.minimumVersions[this.platform]);
  }
  get urlToStore() {
    switch (this.platform) {
      case "android":
        return this.androidStoreUrl;
      case "ios":
        return this.iosStoreUrl;
      default:
        return null;
    }
  }
  get runningOnIos() {
    return window.navigator.userAgent.includes("iPad") || window.navigator.userAgent.includes("iPhone");
  }
  get runningOnAndroid() {
    return window.navigator.userAgent.includes("Android");
  }
  get runningOnNativeApp() {
    return window.navigator.userAgent.includes("Wise");
  }
  _permissionStatusRetrieved(permissions) {
    this.permissions = permissions;
  }
  _extractInformationFromMobileUserAgent() {
    const version = window.navigator.userAgent.split("/")?.[1]?.split(" ")?.[0];
    if (window.navigator.userAgent.includes("(Android)")) {
      console.debug("Android user agent detected");
      this.platform = "android";
      this.version = version;
    } else if (window.navigator.userAgent.includes("(iOS)")) {
      console.debug("iOS user agent detected");
      this.platform = "ios";
      this.version = version;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "permissions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _class);
export { NativeAppService as default };